import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import "./style.sass";
import { ClasicSelectTypeNew } from 'components/Forms/Select';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { BarraStepper } from 'components/Credito/BarraStepper';
import { useStorage64 } from 'hooks/useStorageBase64';
import { decodeStorage } from 'functions/storageBase64';
import getShipping from 'services/getShipping';
import { tipoVi, meses, dias, estadosAbreviacion, titulos } from 'constants/variables';
import { ModalError } from 'components/Error/ErrorModal';

export function InformacionPersonalDesktop(props) {
    const { nextPage, cancelar } = props;

    const [shipping, setShupping] = useState({});

    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);
    const [, setInfoPersonalStorage] = useStorage64('infoPersonalStorage', '');
    const datosPersonalesStorage = decodeStorage("infoPersonalStorage")
    const [datosPersonales, setDatosPersonales] = useState(datosPersonalesStorage);

    const [inputNombre, setInputNombre] = useState();
    const [inputApellidoP, setInputApellidoP] = useState();
    const [inputApellidoM, setInputApellidoM] = useState();
    const [inputCorreo, setInputCorreo] = useState();
    const [inputTelefono, setInputTelefono] = useState();

    const [inputCalle, setInputCalle] = useState();
    const [inputNumExt, setInputNumExt] = useState();
    const [inputNumInt, setInputNumInt] = useState();
    const [inputRfc, setInputRfc] = useState();
    const [inputNumDependientes, setInputNumDependientes] = useState();
    const [inputCP, setInputCP] = useState(datosPersonales?.CP);

    const [estado, setEstado] = useState();
    const [municipio, setMunicipio] = useState();
    const [ciudad, setCiudad] = useState();
    const [entreCalles, setEntreCalles] = useState();
    const [colonia, setColonia] = useState();

    const [inputHipoteca, setInputHipoteca] = useState();
    const [inputAnioResidencia, setInputAnioResidencia] = useState();
    const [inputMesesResidencia, setInputMesesResidencia] = useState();
    const [viviendaR, setViviendaR] = useState(false);

    const [errorCode, setErrorCode] = useState()
    const [messageResponse, setMessageResponse] = useState()
    const [sectionActive, setSectionActive] = useState("")
    const [showModalErr, setShowModalErr] = useState(false);


    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            titulo: datosPersonales.titulo,
            nombre: datosPersonales.Nombre,
            apellidoP: datosPersonales.APaterno,
            apellidoM: datosPersonales.AMaterno,
            correo: datosPersonales.Email,
            telefono: datosPersonales.Telefono,

            sexo: datosPersonales.Genero,
            dia: datosPersonales?.FechaNacimiento?.substr(6, 2),
            mes: datosPersonales?.FechaNacimiento?.substr(4, 2),
            anio: datosPersonales?.FechaNacimiento?.substr(0, 4),
            rfc: datosPersonales.RFC,
            numDependientes: datosPersonales.Nodependientes,
            calle: datosPersonales?.Domicilio?.split(',')[0],
            numExt: datosPersonales?.Domicilio?.split(',')[1]?.split(' ')[0],
            numInt: datosPersonales?.Domicilio?.split(',')[1]?.split(' ')[1],
            cp: datosPersonales.CP,
            colonia: datosPersonales.colonia,
            municipio: datosPersonales.municipio,
            estado: datosPersonales.estado,
            ciudad: datosPersonales.ciudad,
            entreCalles: datosPersonales?.EntreCalles,
            tipoVivienda: datosPersonales.TipoVivienda,
            hipoteca: datosPersonales.MontoRenta,
            anioResidencia: datosPersonales.TiempoResAnio,
            mesesResidencia: datosPersonales.TiempoResMes
        }
    })

    useEffect(() => {
        if (inputCP) {
            if (inputCP.length === 5) {
                getShipping({ codigoPostal: inputCP })
                    .then(setShupping)
            }
            else if (inputCP.length < 5 || inputCP.length === 0) {
                setEstado('');
                setMunicipio('');
                setCiudad('');
                setColonia([]);
            }
        }
    }, [inputCP])

    useEffect(() => {
        if (shipping) {
            setEstado(shipping.estado);
            setMunicipio(shipping.municipio);
            setCiudad(shipping.ciudad);

            if (shipping?.code === 200) {
                clearErrors('estado')
                clearErrors("ciudad")
                clearErrors("colonia")
                clearErrors("municipio")
            }

            if (shipping.colonias) {
                if (shipping.colonias.length === 0) {
                    setColonia([]);
                }
                else if (shipping.colonias.length >= 1) {
                    setColonia(shipping.colonias);
                }
            }

            if (shipping?.code === 404) {
                setShowModalErr(true);
                setErrorCode(shipping?.code);
                setSectionActive('cp');
                setMessageResponse(shipping?.error);
            }
        }
    }, [shipping])

    // funcion que calcula el array de años desde la fecha actual con un rango de 100 años
    function rangeYear() {
        const max = new Date().getFullYear() - 15;
        const min = max - 100;
        const years = [];

        for (let i = max; i >= min; i--) {
            years.push({ "id": i, "value": i });
        }
        return years;
    }

    const [genero, setGenero] = useState(false);
    const seleccionarGenero = (e) => {
        setGenero(e.target.value);
    }

    // validaciones paso 1
    const valTitulo = {
        required: 'Campo obligatorio',
        minLength: {
            value: 1,
            message: 'El título es requerido'
        }
    }

    const valNombre = {
        required: 'Campo obligatorio',
        minLength: {
            value: 3,
            message: 'El nombre al menos debe de contener 3 carácteres'
        },
        maxLength: {
            value: 20,
            message: 'El nombre debe contener un máximo de 20 carácteres'
        }
    }
    const valApellidoP = {
        required: 'Campo obligatorio',
        maxLength: {
            value: 20,
            message: 'El apellido paterno debe contener un máximo de 20 carácteres'
        }
    }

    const valApellidoM = {
        // required: 'Campo obligatorio',
        maxLength: {
            value: 20,
            message: 'El apellido materno debe contener un máximo de 20 carácteres'
        }
    }

    const valCorreo = {
        required: 'El Correo electrónico es requerido',
        pattern: {
            value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'El formato de correo electrónico es inválido'
        },
        maxLength: {
            value: 250,
            message: 'El correo electrónico debe contener máximo 250 dígitos'
        }
    }

    const valTelefono = {
        required: 'El teléfono es requerido',
        minLength: {
            value: 10,
            message: 'El teléfono debe de tener 10 dígitos'
        },
        maxLength: {
            value: 10,
            message: 'El teléfono debe de tener 10 dígitos'
        },
        pattern: {
            value: /[0-9]{10}/,
            message: 'El formato de teléfono es inválido'
        }
    };
    // validaciones paso 2
    const valSexo = {
        required: 'Campo obligatorio',
    };
    const valDia = {
        required: 'Campo obligatorio',
    };
    const valMes = {
        required: 'Campo obligatorio',
    };
    const valAnio = {
        required: 'Campo obligatorio',
    };
    const valRfc = {
        required: 'Campo obligatorio',
        minLength: {
            value: 10,
            message: 'Faltan carácteres, Debe ser de al menos 10 carácteres'
        },
        maxLength: {
            value: 13,
            message: 'Debe contener máximo 13 carácteres'
        }
    };
    const valNumDependientes = {
        // required: 'Campo obligatorio',
    };
    const valCalle = {
        required: 'Campo obligatorio',
        maxLength: {
            value: 30,
            message: 'No debe contener más de 30 dígitos'
        }
    };
    const valNumExt = {
        required: 'Campo obligatorio',
    };
    const valNumInt = {
    };
    const valCp = {
        required: 'Campo obligatorio',
        minLength: {
            value: 5,
            message: 'Faltan dígitos. Deben ser 5 dígitos'
        },
        maxLength: {
            value: 5,
            message: 'No debe contener más de 5 dígitos'
        },
        pattern: {
            value: /[0-9]{0,99999}/,
            message: 'El formato de CP es inválido'
        }
    };
    const valColonia = {
        required: 'La Colonia es requerida',
        minLength: {
            value: 1,
            message: 'El estado es requerido'
        },
        maxLength: {
            value: 120,
            message: 'La colonia debe tener un máximo de 120 caracteres'
        }
    };
    const valMunicipio = {
        required: 'Campo obligatorio',
    };
    const valEstado = {
        required: 'Campo obligatorio',
    };
    const valCiudad = {
        required: 'Campo obligatorio',
    };
    const valEntreCalles = {
    };
    const valTipoVivienda = {
        required: 'Campo obligatorio',
        maxLength: {
            value: 10,
            message: 'El monto de contener máximo 10 dígitos'
        }
    }
    const valHipoteca = {
        required: viviendaR
    }
    const valAnioRes = {
        required: 'Campo obligatorio'
    }
    const valMesRes = {
        required: 'Campo obligatorio',
        max: {
            value: 11,
            message: 'La cantidad máxima de meses que puede tener este campo son 11'
        }
    }


    // guarda la informacion enviada en el formulario
    const sendFormInformacionPersonal = data => {
        let resultado = [];
        estadosAbreviacion.map((ele) =>
            ele.completo === String(data.estado).toLowerCase()
                ? resultado.push(ele.inicial)
                : null//resultado.push(data.estado)
        )

        setDatos({
            "Comp": "076",
            "Tienda": "00576",
            "titulo": data.titulo,
            "Nombre": data.nombre,
            "APaterno": data.apellidoP,
            "AMaterno": data.apellidoM,
            "Email": data.correo,
            "Telefono": data.telefono,
            "Celular": data.telefono,

            "Genero": data.sexo,
            "FechaNacimiento": data.anio + data.mes + data.dia,
            "RFC": data.rfc,
            "Nodependientes": Number(data.numDependientes),
            "Domicilio": data.calle + "," + data.numExt + " " + data.numInt,
            "CP": data.cp,
            "Colonia": data.colonia,
            "Estado": resultado[0],
            "Ciudad": data.ciudad,
            "TipoVivienda": data.tipoVivienda,
            "MontoRenta": Number(data.hipoteca),
            "TiempoResAnio": Number(data.anioResidencia),
            "TiempoResMes": Number(data.mesesResidencia)
        })

        SetReturnForm(true);
        // console.log("datos personales---- ", data)
        nextPage(2);
    }

    useEffect(() => {
        if (returnForm === true) {
            setInfoPersonalStorage(datos);
            SetReturnForm(false);
            nextPage(2);
        }
    }, [returnForm])

    const resetErrors = (value) => {
        let inputId = document.querySelector(`#${value} ~ .error`)
        if (inputId) {
            let valu = value
            clearErrors(valu)
            // reset({
            //     titulo: datosPersonales.titulo,
            //     nombre: datosPersonales.Nombre,
            //     apellidoP: datosPersonales.APaterno,
            //     apellidoM: datosPersonales.AMaterno,
            //     correo: datosPersonales.Email,
            //     telefono: datosPersonales.Telefono
            // });
        }
    }

    const validaDia = () => {
        let mesSelect = document.querySelector("#mes")?.value
        let anioSelect = document.querySelector("#anio")?.value

        if (mesSelect === "02") {
            if (Number(anioSelect) % 400 === 0 || Number(anioSelect) % 4 === 0) {
                if (Number(document.querySelector("#dia")?.value) >= Number(30)) {
                    document.querySelectorAll(`#dia option`)[29].selected = true
                }
            } else {
                if (Number(document.querySelector("#dia")?.value) >= Number(29)) {
                    document.querySelectorAll(`#dia option`)[28].selected = true
                }
            }
        }
        else if (mesSelect === "04" || mesSelect === "06" || mesSelect === "09" || mesSelect === "11") {
            if (Number(document.querySelector("#dia")?.value) === Number(31)) {
                document.querySelectorAll(`#dia option`)[30].selected = true
            }
        }

        if (document.querySelector('#tipoVivienda').value === "R" || document.querySelector('#tipoVivienda').value === 'X') {
            setViviendaR('Campo obligatorio')
        } else if (document.querySelector('#tipoVivienda').value === "O" || document.querySelector('#tipoVivienda').value === 'P') {
            resetErrors('tipoVivienda')
            setViviendaR(false)
        }

    }

    // realiza accion al cerrar modal error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (String(sectionActive) === 'cp') {
            setInputCP();
            document.getElementById("cp").value = "";
        }
    }

    return (
        <>
            <BarraStepper itemActivo={1} />

            <form onSubmit={handleSubmit(sendFormInformacionPersonal)} onChange={validaDia}>
                <div className="infoPersonalGeneral">
                    <div className="infoPersonalTitle">
                        <p>Verifica tu información</p>
                    </div>

                    <div className="infoPersonalForm">
                        <>
                            <div className="divForm">
                                <ClasicSelectTypeNew
                                    type="text"
                                    name="titulo"
                                    id="titulo"
                                    placeholder="Título"
                                    className="desktopInput"
                                    refs={register(valTitulo)}
                                    options={titulos}
                                    errorMessage={errors.titulo && errors.titulo.message}
                                />
                            </div>

                            <div className="divForm">
                                <InputTypeAndroid
                                    type="text"
                                    name="nombre"
                                    id="nombre"
                                    placeholder="Nombre"
                                    refs={register(valNombre)}
                                    className="desktopInput"
                                    autocomplete='name'
                                    setNumero={setInputNombre}
                                    numero={inputNombre}
                                    // value={inputNombre}
                                    errorMessage={errors.nombre && errors.nombre.message}
                                    pattern={'textOnly'}
                                    maxLength={20}
                                    click={() => resetErrors('nombre')}
                                />
                            </div>

                            <div className="divForm">
                                <InputTypeAndroid
                                    type="text"
                                    name="apellidoP"
                                    id="apellidoP"
                                    placeholder="Apellido Paterno"
                                    refs={register(valApellidoP)}
                                    className="desktopInput"
                                    setNumero={setInputApellidoP}
                                    numero={inputApellidoP}
                                    // value={inputApellidoP}
                                    errorMessage={errors.apellidoP && errors.apellidoP.message}
                                    pattern={'textOnly'}
                                    maxLength={20}
                                    click={() => resetErrors('apellidoP')}
                                />
                            </div>

                            <div className="divForm">
                                <InputTypeAndroid
                                    type="text"
                                    name="apellidoM"
                                    id="apellidoM"
                                    placeholder="Apellido Materno"
                                    refs={register(valApellidoM)}
                                    className="desktopInput"
                                    setNumero={setInputApellidoM}
                                    numero={inputApellidoM}
                                    // value={inputApellidoM}
                                    errorMessage={errors.apellidoM && errors.apellidoM.message}
                                    pattern={'textOnly'}
                                    maxLength={20}
                                    click={() => resetErrors('apellidoM')}
                                />
                            </div>

                            <div className="divForm">
                                <InputTypeAndroid
                                    type="text"
                                    name="correo"
                                    id="correo"
                                    placeholder="Correo electrónico"
                                    refs={register(valCorreo)}
                                    className="desktopInput"
                                    autocomplete='email'
                                    setNumero={setInputCorreo}
                                    numero={inputCorreo}
                                    // value={inputCorreo}
                                    errorMessage={errors.correo && errors.correo.message}
                                    pattern={'textOnly'}
                                    maxLength={250}
                                    click={() => resetErrors('correo')}
                                />
                            </div>

                            <div className="divForm">
                                <InputTypeAndroid
                                    type="text"
                                    name="telefono"
                                    id="telefono"
                                    placeholder="Número celular"
                                    refs={register(valTelefono)}
                                    className="desktopInput"
                                    autocomplete='tel'
                                    setNumero={setInputTelefono}
                                    // value={inputTelefono}
                                    numero={inputTelefono}
                                    errorMessage={errors.telefono && errors.telefono.message}
                                    pattern={'number'}
                                    maxLength={10}
                                    click={() => resetErrors('telefono')}
                                />
                            </div>
                        </>
                    </div>

                    <div className="viviendaBox">
                        <div className="secEmpleo">
                            <div className="campo boxSexo">
                                <div className="subCampo">
                                    <p className="strong">Sexo:</p>

                                    <ul className={genero === false && errors.sexo && errors.sexo.message ? "ulSexo conError" : "ulSexo"} onChange={seleccionarGenero}>
                                        <li id="masculino">
                                            <input className="radio" id="m" type="radio" value="M" name="sexo" checked={genero === "M" ? true : false} ref={register(valSexo)} />
                                            <label name="m" htmlFor="m"> Masculino </label>
                                        </li>
                                        <li id="femenino">
                                            <input className="radio" id="f" type="radio" value="F" name="sexo" checked={genero === "F" ? true : false} ref={register(valSexo)} />
                                            <label name="f" htmlFor="f"> Femenino </label>
                                        </li>
                                    </ul>

                                    {genero === false && errors.sexo && errors.sexo.message
                                        ? <div className="error">Campo obligatorio</div>
                                        : null
                                    }
                                </div>
                            </div>

                            <div className="campo">
                                <div className="subCampo">
                                    <p className="strong">Fecha de Nacimiento:</p>
                                    <div className="doble">
                                        <ClasicSelectTypeNew
                                            type="text"
                                            name="dia"
                                            id="dia"
                                            placeholder="Día"
                                            className="desktopInput"
                                            refs={register(valDia)}
                                            options={dias}
                                            errorMessage={errors.dia && errors.dia.message}
                                        />
                                    </div>
                                    <div className="doble">
                                        <ClasicSelectTypeNew
                                            type="text"
                                            name="mes"
                                            id="mes"
                                            placeholder="Mes"
                                            className="desktopInput"
                                            refs={register(valMes)}
                                            options={meses}
                                            errorMessage={errors.mes && errors.mes.message}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="campo">
                                <div className="subCampo">
                                    <p className="strong"></p>
                                    <div className="doble">
                                        <ClasicSelectTypeNew
                                            type="text"
                                            name="anio"
                                            id="anio"
                                            placeholder="Año"
                                            className="desktopInput"
                                            refs={register(valAnio)}
                                            options={rangeYear()}
                                            errorMessage={errors.anio && errors.anio.message}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="secEmpleo">
                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="rfc"
                                    name="rfc"
                                    placeholder="RFC"
                                    className="desktopInput"
                                    errorMessage={errors.rfc && errors.rfc.message}
                                    refs={register(valRfc)}
                                    minLength={10}
                                    maxLength={13}
                                    setNumero={setInputRfc}
                                    // value={inputRfc}
                                    numero={inputRfc}
                                    pattern={'textOnly'}
                                // click={() => resetErrors('rfc')}
                                />
                            </div>
                            <div className="campo">
                                <InputTypeAndroid
                                    type="text"
                                    id="numDependientes"
                                    name="numDependientes"
                                    autocomplete="numDependientes"
                                    placeholder="No. dependientes"
                                    className="desktopInput"
                                    errorMessage={errors.numDependientes && errors.numDependientes.message}
                                    refs={register(valNumDependientes)}
                                    setNumero={setInputNumDependientes}
                                    value={inputNumDependientes}
                                    pattern={'number'}
                                    maxLength={2}
                                />
                            </div>
                        </div>

                        <>
                            <p className="titleVivienda">Vivienda</p>
                            <div className="secEmpleo">

                                <div className="campo">
                                    <InputTypeAndroid
                                        type="text"
                                        id="calle"
                                        name="calle"
                                        placeholder="Calle"
                                        className="desktopInput"
                                        errorMessage={errors.calle && errors.calle.message}
                                        refs={register(valCalle)}
                                        pattern={'textOnly'}
                                        setNumero={setInputCalle}
                                        // value={inputCalle}
                                        numero={inputCalle}
                                        maxLength={30}
                                    />
                                </div>

                                <div className="campo">
                                    <div className="doble">
                                        <InputTypeAndroid
                                            type="text"
                                            id="numExt"
                                            name="numExt"
                                            placeholder="Núm ext."
                                            className="w25"
                                            errorMessage={errors.numExt && errors.numExt.message}
                                            refs={register(valNumExt)}
                                            setNumero={setInputNumExt}
                                            // value={inputNumExt}
                                            numero={inputNumExt}
                                            pattern={'textOnly'}
                                            maxLength={5}
                                        />
                                    </div>
                                    <div className="doble">
                                        <InputTypeAndroid
                                            type="text"
                                            id="numInt"
                                            name="numInt"
                                            placeholder="Núm int."
                                            className="w25"
                                            errorMessage={errors.numInt && errors.numInt.message}
                                            refs={register(valNumInt)}
                                            setNumero={setInputNumInt}
                                            value={inputNumInt}
                                            pattern={'textOnly'}
                                            maxLength={5}
                                        />
                                    </div>
                                </div>

                                <div className="campo">
                                    <div className="doble">
                                        <InputTypeAndroid
                                            type="text"
                                            id="cp"
                                            name="cp"
                                            placeholder="Código Postal"
                                            className="w25"
                                            errorMessage={errors.cp && errors.cp.message}
                                            refs={register(valCp)}
                                            pattern={'number'}
                                            maxLength={5}
                                            setNumero={setInputCP}
                                            // value={inputCP}
                                            numero={inputCP}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="secEmpleo">

                                <div className="campo">
                                    {colonia && colonia.length >= 2
                                        ?
                                        <ClasicSelectTypeNew
                                            type="text"
                                            name="colonia"
                                            id="colonia"
                                            placeholder="Colonia"
                                            className="desktopInput"
                                            refs={register(valColonia)}
                                            options={colonia}
                                            errorMessage={errors.colonia && errors.colonia.message}
                                        />
                                        : <InputTypeAndroid
                                            type="text"
                                            name="colonia"
                                            id="colonia"
                                            placeholder="Colonia"
                                            refs={register(valColonia)}
                                            value={colonia}
                                            readonly="readonly"
                                            className="desktopInput"
                                            errorMessage={errors.colonia && errors.colonia.message}
                                        />
                                    }
                                </div>

                                <div className="campo">
                                    <InputTypeAndroid
                                        type="text"
                                        id="municipio"
                                        name="municipio"
                                        autocomplete="municipio"
                                        placeholder="Municipio"
                                        className="desktopInput"
                                        errorMessage={errors.municipio && errors.municipio.message}
                                        refs={register(valMunicipio)}
                                        value={municipio}
                                        readonly="readonly"
                                    />
                                </div>
                                <div className="campo">
                                    <InputTypeAndroid
                                        type="text"
                                        id="estado"
                                        name="estado"
                                        autocomplete="estado"
                                        placeholder="Estado"
                                        className="desktopInput"
                                        errorMessage={errors.estado && errors.estado.message}
                                        refs={register(valEstado)}
                                        value={estado}
                                        readonly="readonly"
                                    />
                                </div>
                            </div>

                            <div className="secEmpleo">
                                <div className="campo">
                                    <InputTypeAndroid
                                        type="text"
                                        id="ciudad"
                                        name="ciudad"
                                        autocomplete="ciudad"
                                        placeholder="Ciudad"
                                        className="desktopInput"
                                        errorMessage={errors.ciudad && errors.ciudad.message}
                                        refs={register(valCiudad)}
                                        setNumero={setEntreCalles}
                                        value={ciudad}
                                        readonly="readonly"
                                    />
                                </div>
                                <div className="campo">
                                    <InputTypeAndroid
                                        type="text"
                                        id="entreCalles"
                                        name="entreCalles"
                                        placeholder="Entre calles (opcional)"
                                        className="desktopInput"
                                        errorMessage={errors.entreCalles && errors.entreCalles.message}
                                        refs={register(valEntreCalles)}
                                        setNumero={setEntreCalles}
                                        value={entreCalles}
                                    />
                                </div>
                            </div>

                            <div className="secEmpleo">
                                <div className="campo">
                                    <ClasicSelectTypeNew
                                        type="text"
                                        name="tipoVivienda"
                                        id="tipoVivienda"
                                        placeholder="Tipo de vivienda"
                                        className="desktopInput"
                                        refs={register(valTipoVivienda)}
                                        options={tipoVi}
                                        errorMessage={errors.tipoVivienda && errors.tipoVivienda.message}
                                    />

                                </div>

                                <div className="campo">
                                    <InputTypeAndroid
                                        type="text"
                                        name="hipoteca"
                                        id="hipoteca"
                                        placeholder="Hipoteca / Renta"
                                        refs={register(valHipoteca)}
                                        className="desktopInput"
                                        autocomplete='hipoteca'
                                        setNumero={setInputHipoteca}
                                        value={inputHipoteca}
                                        errorMessage={viviendaR ? errors.hipoteca && errors.hipoteca.message : null}
                                        pattern={'number'}
                                        maxLength={10}
                                    // click={() => resetErrors('hipoteca')}
                                    />

                                </div>

                                <div className="campo">
                                    <div className="subCampo">
                                        <p>Tiempo de residir en esta dirección</p>
                                        <div className="doble">
                                            <InputTypeAndroid
                                                type="text"
                                                name="anioResidencia"
                                                id="anioResidencia"
                                                placeholder="Años"
                                                refs={register(valAnioRes)}
                                                className="desktopInput labelRight"
                                                autocomplete='anioResidencia'
                                                setNumero={setInputAnioResidencia}
                                                // value={inputAnioResidencia}
                                                numero={inputAnioResidencia}
                                                errorMessage={errors.anioResidencia && errors.anioResidencia.message}
                                                pattern={'number'}
                                                maxLength={2}
                                            // click={() => resetErrors('anioResidencia')}
                                            />

                                        </div>
                                        <div className="doble">
                                            <InputTypeAndroid
                                                type="text"
                                                name="mesesResidencia"
                                                id="mesesResidencia"
                                                placeholder="Meses"
                                                refs={register(valMesRes)}
                                                className="desktopInput labelRight"
                                                autocomplete='mesesResidencia'
                                                setNumero={setInputMesesResidencia}
                                                // value={inputMesesResidencia}
                                                numero={inputMesesResidencia}
                                                errorMessage={errors.mesesResidencia && errors.mesesResidencia.message}
                                                pattern={'number'}
                                                maxLength={2}
                                                max={11}
                                                min={1}
                                            // click={() => resetErrors('mesesResidencia')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    </div>
                </div>

                <div className="botones">
                    <button className="btnRedCard">Continuar</button>
                    <button className="btnWhite" onClick={cancelar}>Cancelar</button>
                </div>
            </form>

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    section={sectionActive}
                    message={messageResponse}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}
